import { useLayoutEffect, useRef } from "react";

// Ref that always holds the latest value; read it inside effects that must not re-run when it changes.
export function useLatest(value) {
    const ref = useRef(value);
    useLayoutEffect(() => {
        ref.current = value;
    });
    return ref;
}
